import { render, staticRenderFns } from "./Komiidie.vue?vue&type=template&id=2aef4324&scoped=true&"
import script from "./Komiidie.vue?vue&type=script&lang=js&"
export * from "./Komiidie.vue?vue&type=script&lang=js&"
import style0 from "./Komiidie.vue?vue&type=style&index=0&id=2aef4324&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aef4324",
  null
  
)

export default component.exports